import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class LoginService extends Service {
  realizarLogin (codUsuario, senha) {
    return this.getLoginApi().realizarLogin(codUsuario, senha);
  }
}

export default LoginService;
